var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationLine = function SvgNotificationLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7D2853",
    fillRule: "evenodd",
    d: "M5.29 10.357V5.079c0-2.217 2.423-3.936 4.508-3.936h.27c2.085 0 4.508 1.72 4.508 3.936v5.278l2.95 3.787H2.34l2.951-3.787Zm4.711 6.214h-.136a1.685 1.685 0 0 1-1.582-1.11h3.3a1.685 1.685 0 0 1-1.582 1.11Zm9.865-1.284L15.72 9.964V5.079c0-2.907-2.984-5.079-5.65-5.079h-.271c-2.667 0-5.65 2.172-5.65 5.079v4.885L0 15.287h7.08a2.82 2.82 0 0 0 2.785 2.427h.136a2.82 2.82 0 0 0 2.785-2.427h7.08Z"
  })));
};
export default SvgNotificationLine;